import { render, staticRenderFns } from "./General.vue?vue&type=template&id=c983e8b2&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c983e8b2')) {
      api.createRecord('c983e8b2', component.options)
    } else {
      api.reload('c983e8b2', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=c983e8b2&", function () {
      api.rerender('c983e8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/General.vue"
export default component.exports